import {
  AREA_PATH,
  AREAS_PATH,
  AuthRedirect,
  BOOK_PATH,
  BOOKING_HISTORY_PATH,
  BOOKING_REVIEW_PATH,
  BOOKING_UPCOMING_PATH,
  HOME_PATH,
  LOCATION_PATH,
  PROFILE_PATH,
  STAMP_CARD_PATH,
  SUPPORT_PATH,
  THANK_YOU_PATH,
} from '@supsupclub/ui-components';
import { lazy } from 'react';

const HomeView = lazy(() =>
  import('../user/views/home').then((m) => ({ default: m.HomeView })),
);
const BookingAreas = lazy(() =>
  import('./components/booking-flow/booking-areas').then((m) => ({
    default: m.BookingAreas,
  })),
);
const BookingLocations = lazy(() =>
  import('./components/booking-flow/booking-locations').then((m) => ({
    default: m.BookingLocations,
  })),
);
const BookRedirect = lazy(() =>
  import('./components/booking-flow/booking-redirect').then((m) => ({
    default: m.BookRedirect,
  })),
);
const BookingSlots = lazy(() =>
  import('./components/booking-flow/booking-slots').then((m) => ({
    default: m.BookingSlots,
  })),
);
const BookingReview = lazy(() =>
  import('./components/booking-review').then((m) => ({
    default: m.BookingReview,
  })),
);
const BookView = lazy(() =>
  import('./views/booking').then((m) => ({ default: m.BookView })),
);
const BookingDetailsView = lazy(() =>
  import('./views/booking-details').then((m) => ({
    default: m.BookingDetailsView,
  })),
);
const BookingHistory = lazy(() =>
  import('./views/booking-history').then((m) => ({
    default: m.BookingHistory,
  })),
);
const ProfileView = lazy(() =>
  import('./views/profile').then((m) => ({ default: m.ProfileView })),
);
const StampCardView = lazy(() =>
  import('./views/stamp-card').then((m) => ({ default: m.StampCardView })),
);
const SupportView = lazy(() =>
  import('./views/support').then((m) => ({ default: m.SupportView })),
);
const ThankYouView = lazy(() =>
  import('./views/thank-you/thank-you').then((m) => ({
    default: m.ThankYouView,
  })),
);

export const userRoutes = [
  {
    path: HOME_PATH,
    label: 'Home',
    element: (
      <AuthRedirect>
        <HomeView />
      </AuthRedirect>
    ),
  },
  {
    path: BOOK_PATH,
    label: 'Book',
    element: (
      <AuthRedirect>
        <BookView />
      </AuthRedirect>
    ),
    children: [
      {
        path: '',
        label: 'Book Redirect',
        element: (
          <AuthRedirect>
            <BookRedirect />
          </AuthRedirect>
        ),
      },
      {
        path: AREAS_PATH,
        label: 'Areas',
        element: (
          <AuthRedirect>
            <BookingAreas />
          </AuthRedirect>
        ),
      },
      {
        path: AREA_PATH,
        label: 'Area',
        element: (
          <AuthRedirect>
            <BookingLocations />
          </AuthRedirect>
        ),
      },
      {
        path: LOCATION_PATH,
        label: 'Location',
        element: (
          <AuthRedirect>
            <BookingSlots />
          </AuthRedirect>
        ),
      },
      {
        path: BOOKING_REVIEW_PATH,
        label: 'Review',
        element: (
          <AuthRedirect>
            <BookingReview />
          </AuthRedirect>
        ),
      },
    ],
  },
  {
    path: THANK_YOU_PATH,
    label: 'Thank You',
    element: <ThankYouView />,
  },
  {
    path: SUPPORT_PATH,
    label: 'Support',
    element: (
      <AuthRedirect>
        <SupportView />
      </AuthRedirect>
    ),
  },
  {
    path: BOOKING_UPCOMING_PATH,
    element: <BookingDetailsView />,
  },
  {
    path: PROFILE_PATH,
    label: 'Profile',
    element: (
      <AuthRedirect withAuth>
        <ProfileView />
      </AuthRedirect>
    ),
  },
  {
    path: STAMP_CARD_PATH,
    label: 'Stamp Card',
    element: (
      <AuthRedirect>
        <StampCardView />
      </AuthRedirect>
    ),
  },
  {
    path: BOOKING_HISTORY_PATH,
    label: 'Booking History',
    element: (
      <AuthRedirect withAuth>
        <BookingHistory />
      </AuthRedirect>
    ),
  },
];
